import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import ChannelSettingsForm from './ChannelSettingsForm';
import i18n from 'i18n';

interface ChannelSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeChannel: number;
}

const ChannelSettingsModal: React.FC<ChannelSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeChannel,
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_channel_settings.text')}
        entityId={activeChannel}
        FormComponent={ChannelSettingsForm}
    />
));

export default ChannelSettingsModal;
